// Vorgangsstatus, die ein stornierter Vorgang annehmen kann und die in der
// Rechnungsprüfung sichtbar bleiben
export const STORNIERTE_BLANK_STATES = ['StornierteBuchung', 'StorniertOhneRechnung'];

// Prüft, ob der Vorgang einer Zeile storniert ist
export function istVorgangStorniert(data) {
  return STORNIERTE_BLANK_STATES.includes(data?.blankState);
}

// Storno- und Teilstornozeilen behalten auch bei storniertem Vorgang ihre Funktion
export function istStornozeile(data) {
  return data?.leistungstyp === 'Storno' || data?.leistungstyp === 'Teilstorno';
}

// Erhaltene Ursprungszeile eines stornierten Vorgangs und gelöschte Zeilen, nur noch zur Ansicht
export function istNurLesbar(data) {
  if (data?.deletedAt) return true;
  return istVorgangStorniert(data) && !istStornozeile(data);
}
